/**
 * KitchenScene - Interactive kitchen background with SVG elements
 */

import { forwardRef } from 'react';
import './KitchenScene.css';

const KitchenScene = forwardRef(({ fridgeOpen, highlightItem }, ref) => {
  return (
    <div className="kitchen">
      {/* Wall */}
      <div className="kitchen__wall">
        {/* Window */}
        <div className="kitchen__window">
          <div className="window__sky">
            <div className="window__sun" />
            <div className="window__cloud window__cloud--1" />
            <div className="window__cloud window__cloud--2" />
          </div>
          <div className="window__frame">
            <div className="window__divider window__divider--h" />
            <div className="window__divider window__divider--v" />
          </div>
        </div>

        {/* Shelves with items */}
        <div className="kitchen__shelf kitchen__shelf--left">
          <span className="shelf__item">🍪</span>
          <span className="shelf__item">🥣</span>
        </div>
        
        <div className="kitchen__shelf kitchen__shelf--right">
          <span className="shelf__item">🍽️</span>
          <span className="shelf__item">🥤</span>
        </div>
      </div>

      {/* Floor */}
      <div className="kitchen__floor">
        <div className="floor__pattern" />
        <div className="floor__shadow" />
      </div>

      {/* Counter */}
      <div className="kitchen__counter">
        <div className="counter__top" />
        <div className="counter__front">
          <div className="counter__drawer" />
          <div className="counter__drawer" />
        </div>
      </div>

      {/* Fridge */}
      <div className={`kitchen__fridge ${fridgeOpen ? 'kitchen__fridge--open' : ''}`}>
        <div className="fridge__body">
          {/* Inside contents (visible when open) */}
          <div className="fridge__inside">
            <div className={`fridge__item ${highlightItem === 'juice' ? 'fridge__item--highlight' : ''}`}>
              🧃
            </div>
            <div className={`fridge__item ${highlightItem === 'apple' ? 'fridge__item--highlight' : ''}`}>
              🍎
            </div>
            <div className={`fridge__item ${highlightItem === 'milk' ? 'fridge__item--highlight' : ''}`}>
              🥛
            </div>
            <div className="fridge__item">🧀</div>
          </div>
          
          {/* Door */}
          <div className="fridge__door">
            <div className="fridge__handle" />
          </div>
        </div>
        
        {/* Fridge glow when open */}
        {fridgeOpen && <div className="fridge__glow" />}
      </div>

      {/* Ambient particles */}
      <div className="kitchen__particles">
        {[...Array(6)].map((_, i) => (
          <div 
            key={i}
            className="kitchen__particle"
            style={{
              left: `${15 + Math.random() * 70}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${8 + Math.random() * 4}s`,
            }}
          />
        ))}
      </div>
    </div>
  );
});

KitchenScene.displayName = 'KitchenScene';

export default KitchenScene;
